import * as React from 'react';
import * as styles from '../components/BoardMenuItem.scss';
import { ContextualMenuItemType, IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import { hasSelectedProject, getSelectedProjectId } from 'owa-timestream-store';
import { getSortedBoardProjects } from 'owa-calendar-board-projects';
import { lazyOpenBoardEditorDialog } from 'owa-calendar-board-editor';
import BoardMenuItem from '../components/BoardMenuItem';
import loc from 'owa-localize';
import { newBoardButtonText } from './getBoardViewSubMenuItems.locstring.json';

export default function getBoardViewSubMenuItems(
    onSubMenuItemClick?: () => void
): IContextualMenuItem[] {
    let boardProjects: IContextualMenuItem[] = [];
    const projects = getSortedBoardProjects();
    projects.map((project, index) => {
        boardProjects.push({
            key: project.projectId,
            text: project.name,
            title: project.name,
            canCheck: true,
            checked: hasSelectedProject() && getSelectedProjectId() === project.projectId,
            onClick: () => {
                onSubMenuItemClick?.();
            },
            onRender: onRenderBoardMenuItem,
            data: {
                projectId: project.projectId,
            },
        });
    });

    boardProjects.splice(1, 0, {
        key: 'divider_0',
        itemType: ContextualMenuItemType.Divider,
    });

    boardProjects.push({
        key: 'divider_1',
        itemType: ContextualMenuItemType.Divider,
    });

    boardProjects.push({
        key: 'newBoard',
        className: styles.newBoardMenuItem,
        text: loc(newBoardButtonText),
        canCheck: false,
        iconProps: {
            iconName: ControlIcons.Add,
        },
        onClick: () => {
            lazyOpenBoardEditorDialog.importAndExecute();
        },
    });

    return boardProjects;
}

function onRenderBoardMenuItem(
    item: IContextualMenuItem,
    dismissMenu: (ev?: any, dismissAll?: boolean) => void
) {
    return <BoardMenuItem {...item} dismissMenu={dismissMenu} />;
}
